export const probeProjectsQuery = /* GraphQL */ `
  query ProbeProjects($organizationID: ID!, $limit: Int, $nextToken: String) {
    projectsByOrganization(
      organizationID: $organizationID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`

export const probeProjectMembershipQuery = /* GraphQL */ `
  query ProbeProjectMembership(
    $userID: ID!
    $filter: ModelOrganizationMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    organizationMemberbyUser(
      userID: $userID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        project {
          id
        }
      }
      nextToken
    }
  }
`

export const probeReferencePropertiesByUserQuery = /* GraphQL */ `
  query ProbeReferencePropertiesByUser(
    $byUserID: ID!
    $filter: ModelReferencePropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReferencePropertyByByUserID(
      byUserID: $byUserID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`

export const probeReferencePropertiesByOrganizationQuery = /* GraphQL */ `
  query ProbeReferencePropertiesByOrganization(
    $organizationID: ID!
    $filter: ModelReferencePropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    referencesByOrganization(
      organizationID: $organizationID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`

export const probeSavedSearchByUserQuery = /* GraphQL */ `
  query ProbeSavedSearchByUser(
    $byUserID: ID!
    $limit: Int
    $nextToken: String
    $filter: ModelSavedSearchFilterInput
  ) {
    savedSearchByUser(
      byUserID: $byUserID
      limit: $limit
      nextToken: $nextToken
      filter: $filter
    ) {
      items {
        id
      }
      nextToken
    }
  }
`

export const probeSavedSearchByOrganizationQuery = /* GraphQL */ `
  query ProbeSavedSearchByOrganization(
    $organizationID: ID!
    $limit: Int
    $nextToken: String
    $filter: ModelSavedSearchFilterInput
  ) {
    savedSearchByOrganization(
      organizationID: $organizationID
      limit: $limit
      nextToken: $nextToken
      filter: $filter
    ) {
      items {
        id
      }
      nextToken
    }
  }
`
